/**
 * 套餐服务：可购套餐列表、购买套餐、我的套餐。
 *
 * @module services/package
 */
import type { Package, UserPackage } from '@/types';
import { API } from '@/config/api';
import { request } from './http';

/** 列出可购套餐。 */
export async function listPackages(): Promise<Package[]> {
  return request<Package[]>({ method: 'GET', url: API.package.list });
}

/** 购买套餐（直接下单，支付方式在订单中处理）。 */
export async function purchasePackage(packageId: number): Promise<UserPackage> {
  return request<UserPackage>({
    method: 'POST',
    url: API.package.purchase(packageId),
  });
}

/** 查询我已购套餐。 */
export async function getMyPackages(): Promise<UserPackage[]> {
  return request<UserPackage[]>({ method: 'GET', url: API.package.myPackages });
}
